export { default } from './DenFraudesBoletoVerdadeiro';
